import { render, staticRenderFns } from "./Ban.vue?vue&type=template&id=6f24b188"
import script from "./Ban.vue?vue&type=script&lang=js"
export * from "./Ban.vue?vue&type=script&lang=js"
import style0 from "./Ban.vue?vue&type=style&index=0&id=6f24b188&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports